import type { Node, NodeProps } from "@xyflow/react";

import { Badge } from "@/components/ui/badge";
import { formatCurrency, formatStatusLabel } from "@/lib/format";
import { getContractStatusBadgeClass } from "@/lib/status-tag-colors";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { ContractNodeData } from "./types";

type ContractFlowNode = Node<ContractNodeData, "contract">;

export function ContractNode({ data }: NodeProps<ContractFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard
        title="Contract"
        rightSlot={
          <Badge variant="outline" className={getContractStatusBadgeClass(data.status)}>
            {formatStatusLabel(data.status, "Unknown")}
          </Badge>
        }
      >
        <p className="text-sm font-semibold">{data.contractNumber || "Contract -"}</p>
        <FlowNodeRow
          label="Total"
          value={typeof data.totalAmount === "number" ? formatCurrency(data.totalAmount) : "-"}
        />
      </FlowNodeCard>
    </>
  );
}
